import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    sunEditor: {
        padding: '0px 15px 15px 15px',
    },
    rootGrid: {
        borderRadius: '0 !important',
        [theme.breakpoints.down('sm')]: {
            padding: '0 20px 20px 20px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '0 15px 15px 15px',
        },
    },
    container: {
        width: '100%', 
        marginBottom: '50px',
        boxShadow: '0px 0px 2px 2px rgba(34, 35, 58, 0.2)',
        ' & > div': {
            border: 'none!important',
        }
    },
    image: {
        width: "100%", 
        height: "150px", 
        margin: "0", 
        objectFit: "cover",
        [theme.breakpoints.down('md')]: {
            height: "140px", 
        },
        [theme.breakpoints.down('sm')]: {
            height: "130px", 
        },
        [theme.breakpoints.down('xs')]: {
            height: "120px", 
        },
    },
    rootTypography: {
        margin: '10px 0',
        paddingLeft: '15px',
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize26px,
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize24px,
            margin: '10px 0',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize20px,
            margin: '5px 0',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize18px,
            margin: '5px 0',
        },
    },
    rootTypographyDate: {
        paddingLeft: '15px',
        color: '#a1a3a3',
        fontSize: themeCommon.fontSize18px,
        marginBottom: '1rem !important',
        '& > span': {
            color: themeCommon.lightBlue,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
}), {
    name: 'NewsDetail',
    index: 1,
})

export default useStyles